import React from 'react';
import { i18nFn, useSpringBigStore, useTheme, } from '@springbig/shared';
import { VStack, Box } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import { useLocation } from 'react-router';
import { AuthTemplate } from '~/pages/auth/AuthTemplate';
import { Button } from '~/shared/Theme';

type WelcomeStepProps = {
    t: i18nFn;
    onEvent: (message: string) => void;
};

export const WelcomeStep = ({
    t,
    onEvent,
}: WelcomeStepProps) => {

    const location = useLocation();
    const { member } = useSpringBigStore();
    const { primary, card } = useTheme();

    const handleViewMessage = (): void => {

        onEvent('messages');
    };

    const WelcomeBody = () => {

        return <VStack space={8} w={"100%"} alignItems={"center"}>
            <VStack w={"100%"}>
                <H3 fontSize={20}>
                    {member?.first_name
                        ? t('ten_dlc.welcome.title', [member.first_name])
                        : t('ten_dlc.welcome.title_anonymous')}
                </H3>
                <Caption maxW={'100%'}>
                    {t('ten_dlc.welcome.description')}
                </Caption>
            </VStack>
            <VStack w="100%" space={4} alignItems="center">
                <Box position="relative" w="100%" alignItems="center">
                    <Button
                        text={'ten_dlc.welcome.view_message'}
                        onPress={handleViewMessage}
                        w={'100%'}
                    />
                    <Box
                        position="absolute"
                        top={-4}
                        right={-4}
                        bg="red"
                        w={4}
                        h={4}
                        borderRadius="full"
                        borderWidth={2}
                        borderColor="white"
                    />
                </Box>
            </VStack>
        </VStack>;
    };

    if (location.pathname.includes('tendlc')) {
        return (
            <AuthTemplate
                body={<WelcomeBody />}
            />
        );
    }

    return <WelcomeBody />;
};
